
const namePre = 'SystemSetting.'
export default {
    path: '/systemSetting',
    name: 'SystemSetting',
    component: resolve => {
        require.ensure([], () => {
            resolve(require('../../views/systemSetting/Index.vue'))
        })
    },
    children: [{ // 公司
        path: 'branchs',
        name: namePre + 'Branchs',
        component: resolve => {
            require.ensure([], () => {
                resolve(require('../../views/systemSetting/Branchs.vue'))
            })
        },
        meta: {
            permission: 'Pages.SystemSetting.Branches'
        }
    }, { // 登记类型
        path: 'registerType',
        name: namePre + 'RegisterType',
        component: resolve => {
            require.ensure([], () => {
                resolve(require('../../views/systemSetting/RegisterTypes.vue'))
            })
        },
        meta: {
            permission: 'Pages.SystemSetting.RegType'
        }
    }, { // 部门
        path: 'businessUnit',
        name: namePre + 'BusinessUnit',
        component: resolve => {
            require.ensure([], () => {
                resolve(require('../../views/systemSetting/BusinessUnits.vue'))
            })
        },
        meta: {
            permission: 'Pages.SystemSetting.BusinessUnit'
        }
    }, { // 长期车辆
        path: 'agreeCompany',
        name: namePre + 'AgreeCompany',
        component: resolve => {
            require.ensure([], () => {
                resolve(require('../../views/systemSetting/AgreeCompanys.vue'))
            })
        },
        meta: {
            permission: 'Pages.SystemSetting.AgreeCompany'
        }
    }]
}



// WEBPACK FOOTER //
// ./src/router/systemSetting/index.js